import React, { useEffect, useState } from 'react'
import BarcodeGenerator from '@components/Barcode/index'
import { generateImage } from '@utils/generateShapeImage'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { useTimeNow } from '@hooks/useTimeNow'
const ReceiptPage = () => {
	const { getMe } = useSelector((state) => state.main)
	const [data, setData] = useState(null)
	const [paidToDate, setPaidToDate] = useState(0)
	const [docTotal, setDocTotal] = useState(0)
	const { timeNow } = useTimeNow()

	useEffect(() => {
		setTimeout(() => {
			window.print()
		}, 1000)
	}, [])

	useEffect(() => {
		const storedData = sessionStorage.getItem('receiptData')
		if (storedData) {
			setData(JSON.parse(storedData))
			const data = JSON.parse(storedData)
			setDocTotal(
				data?.paymentInvoices?.reduce((a, b) => a + b.docTotal, 0),
			)

			console.log('receiptData', data)
		}
	}, [])

	return (
		<div className="p-2 bg-white text-black font-sans">
			<p className="font-bold text-lg text-center">
				({data?.paymentInvoices[0]?.salesOrderDocNum}) Квитанция об
				оплате (Тулов квитанцияси) - {timeNow}
			</p>

			<div className="mt-8  pt-6">
				<div className="flex justify-end">
					<table className="border border-black text-sm w-full">
						<tbody>
							<tr>
								<td className=" border  border-black  px-4 py-2 font-bold text-sm">
									Продавец (Сотувчи):
								</td>
								<td className="border text-sm font-bold border-black px-4 py-2">
									{`${getMe?.firstName} ${getMe?.lastName}`}
								</td>
							</tr>
							<tr>
								<td className=" border  border-black  px-4 py-2 font-bold text-sm">
									Покупатель (Харидор):
								</td>
								<td className="border text-sm font-bold border-black px-4 py-2">
									{data?.cardName}
								</td>
							</tr>
							<tr>
								<td className=" border  border-black  px-4 py-2 font-bold text-sm">
									Стекло в ассортименте на общую сумму
									(ассортиментда ойна нархи):
								</td>
								<td className="border text-sm font-bold border-black px-4 py-2">
									{new Intl.NumberFormat('fr-FR').format(
										docTotal,
									)}{' '}
									{data?.docCurr}
								</td>
							</tr>
							<tr>
								<td className=" border  border-black  px-4 py-2 font-bold text-sm">
									ОПЛАТА:
								</td>
								<td className="border text-sm font-bold border-black px-4 py-2">
									{new Intl.NumberFormat('fr-FR').format(
										data?.cashSum,
									)}{' '}
									{data?.docCurr}
								</td>
							</tr>
							<tr>
								<td className=" border  border-black  px-4 py-2 font-bold text-sm">
									ДОЛГ:
								</td>
								<td className="border text-sm font-bold border-black px-4 py-2">
									{new Intl.NumberFormat('fr-FR').format(
										data?.balance,
									)}{' '}
									{data?.docCurr}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="mt-5">
					<p>
						ВНИМАНИЕ: Допускается отклонение обработанного стекла по
						длине и ширине в пределах +- 2мм согласно ГОСТу
					</p>
					<p className="mt-5">
						Условия вывоза товара: Покупатель после уведомления о
						готовности товара в 5 дневный срок должен вывезти. В
						противном случае за каждый просроченный день обязуется
						платить арендную плату в размере 3000 сум за 1 кв/м
					</p>
					<p className="mt-5">
						Махсулот олиб чикиш шартлари: Харидор уз ойна
						махсулотлари тайерлиги хакида хабар топганидан сунг. 5
						кун ичида олиб кетиши шарт. Акс холда кечиктирилган хар
						бир кун учун 1 кв/м га 3000 сумдан ижара хаки тулайди.
					</p>
				</div>

				<div className="flex items-center justify-between mb-5  ">
					<div className="mt-5  flex flex-col gap-3">
						<p>
							<span className="font-bold">
								Покупатель (Харидор):{' '}
							</span>
							{data?.cardName}
						</p>
						<p>
							<span className="font-bold">Тел:</span>{' '}
							{data?.phoneNumber}
						</p>
					</div>

					<div className="text-left  flex flex-col gap-3">
						<p>
							<span className="font-bold">
								Продавец (Сотувчи):{' '}
							</span>
							{`${getMe.firstName} ${getMe.lastName}`}
						</p>
						<p>
							<span className="font-bold">Тел:</span>{' '}
							{getMe?.mobilePhone}
						</p>
					</div>
					<div></div>
				</div>

				<div className="mt-12 text-xl">
					<p className="font-bold">
						Харидор туловномани курсатиб буюртмасини олишига хакли /
						Товар отпускается строго по платежке
					</p>
				</div>
			</div>
		</div>
	)
}

export default ReceiptPage
